<template>
  <div>
    <file-loader
      @onFileLoad="onFileLoad"
      @onDragOver="fileDragOver = $event"
    >
      <slot :fileDragOver="fileDragOver"></slot>
    </file-loader>

    <image-crop
      v-model="cropModalVisible"
      :image="cropImage"
      :processing="processing"
      :ratio="ratio"
      :cropper-options="{ centerBox: true }"
      @onCrop="saveImageToServer"
    >
    </image-crop>

    <v-dialog
      v-model="gifProcessing"
      persistent
      max-width="290"
    >
      <v-card>
        <div class="flex items-center justify-center p-20 flex-col">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <p class="mb-0 mt-16">
            Processing GIF...
          </p>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorMixin from "@/mixins/errors.mixin";
import presignedApi from "@/services/api/exercise/api-media-presigned"

export default {
  mixins: [ErrorMixin],
  components: {
    imageCrop: () => import('@/components/global/ImageCrop.vue'),
    fileLoader: () => import('@/components/global/FileLoader.vue')
  },
  props: {
    ratio: Array,
  },
  data: () => ({
    cropImage: {},
    cropModalVisible: false,
    fileDragOver: false,
    processing: false,
    compressedGifBlob: null,
    gifProcessing: false,
  }),
  methods: {
    async onFileLoad(file) {
      const isImage = /^image\//.test(file.type);
      const isMp4 = /^video\/mp4/.test(file.type);
      const isGif = /\/gif$/.test(file.type);

      if (isGif) {
        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 1080;

        const compressedBlob = await this.resizeGif(
          file,
          MAX_WIDTH,
          MAX_HEIGHT
        );
        await this.saveImageToServer(compressedBlob);
        this.gifProcessing = false;
        return;
      }

      if (isMp4) {
        await this.saveImageToServer(file);
        return;
      }

      if (!isImage && !isMp4) {
        this.$notify({
          text: 'You can only upload images or MP4 videos.',
          type: 'error'
        });
        return;
      }

      this.cropImage = file;
      this.cropModalVisible = true;
    },

    async loadGifsicle() {
      if (this._gifsicle) return this._gifsicle

      const module = await import(
        /* webpackIgnore: true */
        'https://unpkg.com/gifsicle-wasm-browser/dist/gifsicle.min.js'
      )

      this._gifsicle = module.default
      return this._gifsicle
    },

    async resizeGif(file, maxWidth = 1920, maxHeight = 1080) {
      this.gifProcessing = true;
      const gifsicle = await this.loadGifsicle()

      const result = await gifsicle.run({
        input: [{ file, name: 'input.gif' }],
        command: [
          `--resize-fit 1920x1080 input.gif -o /out/${file.name}`
        ]
      })

      return result[0];
    },

    async saveImageToServer(file) {
      this.processing = true;
      try {
        const presignedData = await presignedApi.createPresignedUpload(file.name);
        await presignedApi.uploadToS3(presignedData.upload_params, file);
        this.$emit('onImageCrop', presignedData.file.file);
        this.cropModalVisible = false;
      } catch (error) {
        this.showErrorModal('Something went wrong');
      } finally {
        this.processing = false;
      }
    }
  },
}
</script>
